import axios from 'axios';
axios.defaults.responseType = 'json';
axios.defaults.withCredentials = true;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Cache-Control'] = 'no-cache,no-store,must-revalidate,max-age=-1,private';
axios.defaults.headers.common.Pragma = 'no-cache';
axios.defaults.headers.common.Expires = 0;
export var getServerErrorMessage = function getServerErrorMessage(res, defaultMessage) {
  var _ref = res && res.response && res.response.data || {},
      message = _ref.message;

  return message || defaultMessage || 'An error occurred, please try again later.';
};
export var enterpriseRequestSettings = {
  withCredentials: false,
  transformRequest: function transformRequest(data, headers) {
    headers.common = {};
    return data;
  }
};
export default axios;